//DEFAULT PKG
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { BrowserModule, Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { ResponsiveModule } from "ng2-responsive";
import { AppComponent } from "./app.component";
import { AppState, InternalStateType } from "./app.service";
import { GlobalState } from "./app.state";
import { ServicesModule } from "./shared/services/services.module";
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from "./app.routing";
import { HttpClientModule } from "@angular/common/http";

//OWN PKG
import { CookieService } from "ng2-cookies";
//Translate
import { HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Dialogs } from './common/dialogs';
import { LoginModule } from "app/pages/public/login/login.module";

import { BaseDatatableComponent } from './pages/base/base-datatable/base-datatable.component';
import { BaseComponentComponent } from './pages/base/base-component/base-component.component';

import { DataService } from "./services/data.service";
import { PublicService } from "./services/public.service";
import { AuthGuardService } from "./services/auth-guard.service";
import { UpdatePhotoService } from "app/services/update-photo.service";
import { MAT_DATE_LOCALE } from '@angular/material';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http);
}

// Application wide providers
const APP_PROVIDERS = [
	AppState,
	GlobalState,
	Title,
	{ provide: LocationStrategy, useClass: HashLocationStrategy },
	CookieService,
	DataService,
	PublicService,
	AuthGuardService,
	Dialogs,
	UpdatePhotoService,
	{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
];

export type StoreType = {
	state: InternalStateType;
	restoreInputValues: () => void;
	disposeOldHosts: () => void;
};

@NgModule({
	declarations: [
		AppComponent,
		BaseDatatableComponent,
		BaseComponentComponent,
	],

	imports: [
		BrowserModule,
		FormsModule,
		HttpModule,
		HttpClientModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		ServicesModule,
		//ResponsiveModule,
		SharedModule.forRoot(),
		AppRoutingModule,
		LoginModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		})
	],
	providers: [APP_PROVIDERS],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(public appState: AppState) { }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts